// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".viewer-root[data-v-41c5aa6c]{position:fixed;overflow:hidden;height:100%;width:100%}\n", ""]);
// Exports
module.exports = exports;
